// This file was automatically generated from uiwidget.Panel.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.Panel');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.Panel.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PanelContainer"><h3 class="panel-title el8DialogHeader"></h3><a class="panel-size-trigger el8PanelCloseButton"></a><div class="panel-content el8PanelContent"></div></div>');
  if (!opt_sb) return output.toString();
};
